import * as Scrivito from "scrivito";
import videoWidgetIcon from "../../assets/images/video_widget.svg";

Scrivito.provideEditingConfig("YouTubeWidget", {
  title: "YouTube Video",
  thumbnail: videoWidgetIcon,
  attributes: {
    videoUrl: {
      title: "YouTube video URL",
      description: "Provide YouTube video URL",
    },
    aspectRatio: {
      title: "Aspect ratio",
      description: "Default: HD TV (16:9)",
      values: [
        { value: "21:9", title: "CinemaScope (21:9)" },
        { value: "16:9", title: "HD TV (16:9)" },
        { value: "4:3", title: "Traditional TV (4:3)" },
        { value: "1:1", title: "Square (1:1)" },
        { value: "3:4", title: "Portrait traditional TV (3:4)" },
        { value: "9:16", title: "Portrait HD TV (9:16)" },
      ],
    },
  },
  properties: ["videoUrl", "title", "aspectRatio"],
  initialContent: {
    aspectRatio: "16:9",
    videoUrl: "https://www.youtube.com/watch?v=RBLwKTEZr00",
  },
});
